import OfferLineItem from "./OfferLineItem";
import InsuranceInfo from "./InsuranceInfo";
import ContactInfo from "./ContactInfo";
import InvoiceInfo from "./InvoiceInfo";
import AttachmentInfo from "./AttachmentInfo";

export default class OfferContent {
  attachments: Array<AttachmentInfo>;
  contactInfo: ContactInfo;
  lineItems: Array<OfferLineItem>;
  insuranceInfo: InsuranceInfo;
  invoiceInfo: InvoiceInfo;
  comment: string;
  warrantyPeriod: number;

  public constructor(
    attachments: Array<AttachmentInfo>,
    contactInfo: ContactInfo,
    lineItems: Array<OfferLineItem>,
    insuranceInfo: InsuranceInfo,
    invoiceInfo: InvoiceInfo,
    comment: string,
    warrantyPeriod: number
  ) {
    this.attachments = attachments;
    this.contactInfo = contactInfo;
    this.lineItems = lineItems;
    this.insuranceInfo = insuranceInfo;
    this.invoiceInfo = invoiceInfo;
    this.comment = comment;
    this.warrantyPeriod = warrantyPeriod;
  }
}
